import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import type { Path } from '~/types/util'

export default class IsMedSuppV2Node extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    const { flag } = FeatureFlags.use()
    const medSuppV2 = computed(() => flag<boolean>('med-supp-v2').value)

    return this.yesNo(medSuppV2.value)
  }

}